import tokens from './tokens';

// Layout configurations based on privacv design system
export const layout = {
  container: {
    maxWidth: '1400px', // From 2xl in the design system
    padding: {
      xs: tokens.spacing[4], // Default: 1rem
      sm: tokens.spacing[8], // sm: 2rem
      md: tokens.spacing[12], // lg: 3rem
      lg: tokens.spacing[16], // xl: 4rem
      xl: tokens.spacing[20], // 2xl: 5rem
    },
    margin: '0 auto',
  },

  sidebar: {
    width: '100px',
    maxHeight: '100vh',
    padding: tokens.spacing[4],
    backgroundColor: tokens.colors.background.paper,
    borderRight: `1px solid ${tokens.colors.borders.default}`,
    boxShadow: tokens.shadows.sm,
  },

  mainContent: {
    flex: 1,
    padding: tokens.spacing[4],
    backgroundColor: tokens.colors.background.default,
  },

  grid: {
    spacing: tokens.spacing[4],
    columns: {
      xs: 1, 
      sm: 1, // sm: 640px
      md: 2, // md: 768px
      lg: 3, // lg: 1024px
      xl: 3, // xl: 1280px
    },
  },

  section: {
    marginBottom: tokens.spacing[8],
    header: {
      marginBottom: tokens.spacing[4],
    },
  },

  // Breakpoints matching the design system
  breakpoints: {
    values: {
      xs: 0,
      sm: 640, // sm: 640px
      md: 768, // md: 768px
      lg: 1024, // lg: 1024px
      xl: 1280, // xl: 1280px
      xxl: 1400, // 2xl: 1400px
    },
  },
};

export default layout; 